import { isSupplier, isSourcer, isBuyer } from '../utils/rbac';
import { useAppSelector } from '../app/hooks';

export const useRole = () => {
  const user = useAppSelector((state) => state.app.user);
  return {
    sourcerRole: isSourcer(user),
    supplierRole: isSupplier(user),
    buyerRole: isBuyer(user),
  };
};
